import { render, staticRenderFns } from "./CustomsDeclarationContract.vue?vue&type=template&id=1f50fd13"
import script from "./CustomsDeclarationContract.vue?vue&type=script&lang=js"
export * from "./CustomsDeclarationContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports